import Constants from '../constants'

export default {
  mixins: [Constants],

  methods: {
    notifyByError() {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.ERROR,
        type: this.NOTIFICATION_TYPES.ERROR_OPERATION
      }}));
    },

    notifyByAddExcursionToCart() {
      window.dispatchEvent(new CustomEvent('changeCartQuantity', { detail: 1 }));
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        type: this.NOTIFICATION_TYPES.ADD_TO_CART,
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
      }}));
    },
    notifyByAddHotelToCart() {
      window.dispatchEvent(new CustomEvent('changeCartQuantity', { detail: 1 }));
      window.dispatchEvent(new CustomEvent('notification', { detail: {
          type: this.NOTIFICATION_TYPES.ADD_TO_CART,
          typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        }}));
    },

    notifyByPersonalDataSaved() {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.PERSONAL_DATA_SAVED
      }}));
    },

    notifyByChangedPassword() {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.PASSWORD_CHANGED
      }}));
    },

    notifyByCreatedReferLink(referLink) {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.REFER_LINK_CREATED,
        referLink: referLink
      }}));
    },

    notifyByActionSetMainReferLink(referLink) {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.REFER_LINK_MAIN_ACTION,
        referLink: referLink
      }}));
    },

    notifyByCreatedCoupon(coupon) {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.COUPON_CREATED,
        coupon: coupon
      }}));
    },

    notifyByDeletedCoupon(coupon) {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.COUPON_DELETED,
        coupon: coupon
      }}));
    },

    notifyBySubscribes() {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.SUBSCRIBED
      }}));
    },

    notifyBySavedLogo() {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.SAVED_LOGO
      }}));
    },

    notifyByFailHotelsLogin() {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.ERROR,
        type: this.NOTIFICATION_TYPES.FAIL_HOTELS_LOGIN
      }}));
    },

    notifyByLeaveFeedback() {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.LEAVE_FEEDBACK
      }}));
    },

    notifyBySentContact() {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.SENT_CONTACT
      }}));
    },

    notifyBySentPartnership() {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.SENT_PARTNERSHIP
      }}));
    },

    notifyBySentHolidayForm() {
      window.dispatchEvent(new CustomEvent('notification', { detail: {
        typeState: this.NOTIFICATION_TYPES_STATE.SUCCESS,
        type: this.NOTIFICATION_TYPES.SENT_HOLIDAY_FORM
      }}));
    }
  }
}
